import React, { useEffect, useState, memo } from "react";
import { Dropdown, Option } from "@fluentui/react-components";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const dataLocations = [
  "United States",
  "Canada",
  "Europe",
  "Australia",
  "South Africa",
  "United Kingdom",
  "UAE",
];

function DataLocation({ value, onSelect }) {
  const { t } = useTranslation();
  const [selected, setSelected] = useState("");

  // 🔁 Synchroniser la valeur interne avec celle du parent
  useEffect(() => {
    if (value && value !== selected) {
      setSelected(value);
    }
  }, [value]);

  const handleChange = (_, data) => {
    const newValue = data.optionValue;
    setSelected(newValue);
    if (onSelect) onSelect(newValue);
  };

  return (
    <Dropdown
      placeholder={t("SELECT_DATA_LOCATION")}
      value={selected || ""}
      onOptionSelect={handleChange}
      appearance="outline"
    >
      {dataLocations.map((loc) => (
        <Option key={loc} value={loc}>
          {loc}
        </Option>
      ))}
    </Dropdown>
  );
}

DataLocation.propTypes = {
  value: PropTypes.string,
  onSelect: PropTypes.func,
};

// ✅ Mémo pour éviter les re-rendus inutiles
export default memo(DataLocation, (prev, next) => prev.value === next.value);
